export default __webpack_public_path__ + "static/3-26-0-0-81442375191f2c32c26caa36a28e7612.jpg";